import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { TitleCard } from '@/core/components';

import { formatDate } from '@feature/utils';

import { mobilityTitle } from '../../MobilityUtils';
import { Mobility } from '../../model/MobilityTypes';
import classes from './MobilityCard.module.css';

export interface MobilityCardProps {
  mobility: Mobility;
  to?: string;

  onClick?: () => void;
}

export function MobilityCard({ mobility, to, onClick }: MobilityCardProps) {
  const { t } = useTranslation();
  const { startDate, endDate, certificate, sourceTravelRequestId } = mobility;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      to={to}
      onClick={onClick}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="12px">
        <TitleCard title={mobilityTitle(t, mobility)} />
        <Text size="sm">
          {t('mobilities.details.period')}: {formatDate(startDate)} - {formatDate(endDate)}
        </Text>
        <Group>
          <Pill>
            {t('mobilities.certificate.title')}: {certificate?.title ?? t('mobilities.certificate.missing')}
          </Pill>
          {sourceTravelRequestId != null && <Pill>{t('mobilities.details.sourceRequest')}</Pill>}
        </Group>
      </Stack>
    </Paper>
  );
}
